import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/scss/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { TreeFooter } from './layouts/Main/components';

import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <div className="content">
      <App />
    </div>
    <TreeFooter />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
